<template>
  <Row>
    <Col span="24">
      <div class="res_div">
        <p class="res_div_p">{{ title }}</p>
        <div class="res_div_div"></div>
        <div style="text-align: center">
          <span class="news_ul_div_div02_sp"> 发布时间：2022-07-07 </span>
        </div>
        <div class="div_img01" v-for="(item, index) in img" :key="index">
          <span
            v-if="item.sp !== ''"
            :src="item.sp"
            style="
              font-size: 17px;
              font-weight: bold;
              color: #70a9f8;
              line-height: 34px;
            "
            >{{ item.sp }}</span
          >
          <p class="font_div">{{ item.p }}</p>
          <img v-if="item.imgUrl !== ''" :src="item.imgUrl" alt="暂无照片" />
          <img
            v-if="item.imgUrl02 !== ''"
            :src="item.imgUrl02"
            alt="暂无照片"
          />
          <img
            v-if="item.imgUrl03 !== ''"
            :src="item.imgUrl03"
            alt="暂无照片"
          />
        </div>
      </div>
    </Col>
  </Row>
</template>

<script>
export default {
  data() {
    return {
      title:
        "热烈欢迎河南省政协副主席高体建等一众领导莅临智慧岛及南秀科技参观指导！",
      img: [
        {
          imgUrl: "../../../static/img/News/NewsSix/NewsSix1.jpg",
          imgUrl02: "../../../static/img/News/NewsSix/NewsSix2.jpg",
          imgUrl03: "",
          p: "7月6日，为打造一流创新平台，建设国家创新高地，河南省政协副主席高体建，省政协常委、教科卫体委员会主任胡广坤 ，省政协常委、教科卫体委员会副主任修振环，省政协委员、省科学技术厅党组书记、厅长陈向平，省科学技术厅副厅长、党组成员夏培臣，郑州大学副校长屈凌波，省科学技术协会党组成员、副主席邓洪军等一众领导莅临智慧岛大厦及南秀科技开展视察活动",
        },
        {
          imgUrl: "../../../static/img/News/news06.jpg",
          imgUrl02: "../../../static/img/News/NewsSix/NewsSix3.jpg",
          imgUrl03: "../../../static/img/News/NewsSix/NewsSix4.jpg",
          p: "领导们在四楼参观南秀科技展台。公司智慧工地管理平台受到领导极大关注,南秀科技负责人王鹏超向领导们详细介绍了该管理平台的技术来源、以及主要应用场景。",
        },
      ],
    };
  },
  mounted() {
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  },
  methods: {
    getUnderStandMore() {
      this.$router.push({
        name: "AR",
      });
    },
  },
};
</script>

<style scoped>
.res_div img {
  width: 100%;
  margin: 10px 0;
}

.res_div_p {
  font-size: 30px;
  font-weight: bold;
  color: #000;
}

.font_div {
  font-size: 16px;
  line-height: 26px;
  margin-bottom: 10px;
}

.res_div_div {
  border-bottom: 1px dashed #e1e1e1;
  margin: 10px 0;
}

.news_ul_div_div02_sp {
  font-size: 12px;
  color: #888;
  line-height: 30px;
}

.div_img01 img {
  width: 96%;
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/News/NewsSix.vue